import React, { useEffect, useState, useContext } from 'react';
import { Capacitor } from '@capacitor/core';
import AdvertisementPlaceholder from './AdvertisementPlaceholder';
import { AdService } from '../AdService';
import { PageContext } from '../PageContext';

const BannerAd: React.FC = () => {
    const [isNative, setIsNative] = useState(false);
    const pageContext = useContext(PageContext);
    const currentPage = pageContext?.pageStack[pageContext.pageStack.length - 1]?.page;

    useEffect(() => {
        const native = Capacitor.isNativePlatform();
        setIsNative(native);
    }, []); // Run once on mount/unmount

    useEffect(() => {
        // Only re-verify visibility on meaningful lifecycle events (handled in App.tsx now)
    }, [currentPage, isNative]);

    // If Native, we render nothing in DOM (Ad is an overlay)
    // If Web, we render AdSense
    if (isNative) {
        return <div className="w-full bg-transparent" style={{ height: 'calc(65px + env(safe-area-inset-bottom))' }}></div>; // Spacer for overlay
    }

    return (
        <div className="flex justify-center w-full overflow-hidden h-[60px] bg-white">
            <AdvertisementPlaceholder 
                format="banner"
                style={{ display: 'inline-block', width: '320px', height: '50px' }} 
            />
        </div>
    );
};

export default BannerAd;